import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Icon,
  Menu,
  Dropdown,
  Col,
  Input,
  Popover,
  Select,
  Button,
  Badge,
  Modal,
  Tooltip,
  Tabs,
} from 'antd';
import {
  TabMenuContainer,
  EmptySettingsDetails,
  HelpGuideWrapper,
  LoaderContainer,
  TabMenuHeaderContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  TabMenuItemDetails,
  SubTabHeading,
  DropdownDetails,
  NoDataView,
  TabSearchContainer,
  PopoverContainer,
  ClearAll,
  NoteText,
  ModalBody,
  PageCountIndicator,
  SearchNavWrapper,
} from './styles';

import EmptyElementsIllustration from '../../images/empty-elements.svg';
import { FilterSvg } from '../../components/SidebarMenuIcons';
import { withTranslation } from 'react-i18next';
import Loader from '../../components/Loader';
import EditorElement from './EditorElementWrapper';
import ApplyTemplate from '../../components/ApplyTemplate';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import DeleteTemplateModal from '../../components/Modals/DeleteTemplateModal';
import PreviewModal from '../../components/Modals/PreviewModal';
import { getAllDocumentsByCategories } from '../../utils/services/categoriesAPI';
import { searchTemplates, getTemplateStatus } from '../../utils/services/templatesAPI';
import AddTagsModal from '../../components/Modals/AddTagsModal';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import { PageElementsContext } from '../../context/pageElementsContext';
import TemplateMenuItem from './TemplateMenuItem';
import { DESIGN_AREA_TEMPLATES_TAB, TEMPLATE_LOCKED_BY_MODAL } from './translationValues';

const { Option } = Select;
const { TabPane } = Tabs;
const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB', 'TEMPLATE_LOCKED_BY_MODAL'];

const TemplateTabDetails = props => {
  const { isBottom, editable, isSelectionMode = false, setIsBottom, onSelect, activetabIndex, attachmentTemp, t } = props;

  const [selectedView, setSelectedView] = useState('view-templates');
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [initialLoader, setInitialLoader] = useState(true);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const { categoryTemplates, updateCategoryTemplates, checkUserAccess, userDetails, lockUnlockTemplateHandler } = useContext(
    AppStoreContext,
  );
  const [loadMore, setLoadMore] = useState(false);
  const [page, setPage] = useState(1);
  const [previousView, setPreviousView] = useState('view-templates');
  const [defaultTemplates, setDefaultTemplates] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [searchedTemplates, setSearchedTemplates] = useState({});
  const [noData, setNodata] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterOption, setFilterOption] = useState('All');
  const [lockedBy, setLockedBy] = useState({});
  const [pageIndex, setPageIndex] = useState(0);
  const [templateType, settemplateType] = useState(
    checkUserAccess('master') ? 'mastertemplate' : 'usertemplate',
  );
  const { handlePageHistory } = useContext(PageElementsContext);
  let history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await getAllDocumentsByCategories(true, true, templateType, isSelectionMode);
      if (response && response.data) {
        const data = response.data;
        let sortByDocs = data.map(item => {
          let documents = item.documents.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
          return { ...item, documents }
      })
        let sortByCategory = sortByDocs.sort((a, b) => new Date(b.documents[0].createdOn) - new Date(a.documents[0].createdOn))
        setDefaultTemplates(sortByCategory);
        updateCategoryTemplates(sortByCategory, 'saveAllCategoryTemplates');
      }
      setFetchingCategories(false);
      setInitialLoader(false);
    })();
    // eslint-disable-next-line
  }, [templateType, isSelectionMode]);


  useEffect(() => {
    if (isBottom && !loadMore && !noData) {
      if (selectedView === 'view-search-template') {
        onSearch();
      }
    }    
    setDefaultTemplates(categoryTemplates);
    // eslint-disable-next-line
  }, [isBottom, categoryTemplates, templateType]);

  const onScroll = e => {
    if (!setIsBottom) return;
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (Math.abs(scrollTop + clientHeight - scrollHeight) < 10) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  }; 

  const updateSelectedView = (view, templateObj, action = undefined) => {
    if (view === 'view-templates') {
      setSearchKey('');
      setFilterOption('All');
      setSelectedCategory(undefined);
      setSearchedTemplates({});
      updateCategoryTemplates(defaultTemplates, 'saveAllCategoryTemplates');
    }
    if (action) {
      setPreviousView(action);
    }
    setSelectedView(view);
    setSelectedTemplate(templateObj);
  };

  const checkTemplateStatus = async template => {
    const templateStatus = await getTemplateStatus(template.id, 'printTemplate');
    if (templateStatus?.data) {
      const { locked, lockedBy } = templateStatus.data;
      if (userDetails && locked && lockedBy) {
        const locked = userDetails.id !== lockedBy.userId;
        if (locked) {
          setLockedBy(lockedBy);
          setSelectedAction('template-locked');
          setUpdateModalVisibility(true);
          return 'template-locked';
        }
      }
    }
  };

  const enableModalVisibility = async (actionType, template) => {
    const checkStatus = ['delete-template', 'add-tag'].some(data => data === actionType);
    setSelectedTemplate(template);
    if (checkStatus) {
      actionType = (await checkTemplateStatus(template)) || actionType;
    }
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
  };

  const previewModalVisibility = (e, actionType, template, pageId) => {
    e.stopPropagation();
    setUpdateModalVisibility(true);
    setSelectedAction(actionType);
    setSelectedTemplate(template);
    setPageIndex(pageId);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setSelectedAction(null);
  };

  const redirectToTemplate = async (template, actionType, updates) => {
    const templateStatus = await checkTemplateStatus(template);
    if (templateStatus !== 'template-locked') {
      let url = window.location.href;
      if (url && editable) {
        lockUnlockTemplateHandler(template.id, 'Template', true);
      }
      if (actionType && actionType === 'saveCategoryTemplate' && updates) {
        updateCategoryTemplates(updates, actionType);
      }
      history.push(`/design/${template.id}`);
      setUpdateModalVisibility(false);
      setSelectedAction(null);
      handlePageHistory([], 'reset');
    }
  };

  const onSuccessDeletion = () => {
    setSelectedView('view-templates');
    setUpdateModalVisibility(false);
  };

  const onSearch = async (first = false, category = selectedCategory, searchParam = searchKey) => {
    let currentPage = page;
    if (first) {
      setPage(1);
      currentPage = 1;
      setNodata(false);
      setFetchingCategories(true);
    }
    const payload = {
      page: currentPage,
      limit: 10,
      categoryId: category?.categoryId || '',
    };
    if (searchParam !== '') {
      payload.searchParam = searchParam;
    }
    setSelectedView('view-search-template');
    setLoadMore(true);
    setFilterOption(category);
    let response = await searchTemplates(payload, templateType, isSelectionMode);
    if (response?.data) {
      const templates = response.data;
      let updatedSearchTemplates = {
        count: response.dataCount,
        templates: first ? templates : [...searchedTemplates?.templates, ...templates],
      };
      setSearchedTemplates(updatedSearchTemplates);
      if (payload.limit * currentPage >= response.dataCount) {
        setNodata(true);
      }
      setPage(currentPage + 1);
    }
    setFetchingCategories(false);
    setLoadMore(false);
  };

  const seeAllByCategory = category => {
    if (category === 'All') {
      updateSelectedView('view-templates', null);
    } else {
      setSelectedCategory(category);
      onSearch(true, category);
    }
  };

  const onClose = () => {
    setSearchKey('');
    if (!selectedCategory) {
      updateSelectedView('view-templates', null);
    } else {
      onSearch(true, undefined, '');
    }
  };

  const onSuccessAddition = success => {
    if (success && (searchKey.length > 0 || selectedCategory)) {
      onSearch(true);
    }
    setUpdateModalVisibility(false);
  };

  const handleTemplateType = key => {
    setTimeout(() => {
      settemplateType(key);
      setFilterVisible(false);
      setFetchingCategories(true);
      updateSelectedView('view-templates', null);
    }, 300);
  };

  const renderLoader = (styles = {}) => (
    <LoaderContainer top={styles.top}>
      <Loader />
      <div className="loading-txt">{t(DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.key, DESIGN_AREA_TEMPLATES_TAB.LOADING_MORE_TEMPLATES_TEXT.value)}</div>
    </LoaderContainer>
  );

  const renderSearchBar = () => {
    return (
      <TabSearchContainer Master={isSelectionMode || checkUserAccess('master')} inverted={isSelectionMode ? 1 : 0}>
        <Input
          name="templateSearch"
          placeholder={t(DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.key, DESIGN_AREA_TEMPLATES_TAB.SEARCH_TEMPLATES_PLACEHOLDER.value)}
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={() => onSearch(true)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={"off"}
          suffix={
            <>
              {searchKey.length > 0 && <Icon type="close" onClick={onClose} />}
              <Popover
                placement="bottomRight"
                title={t(DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.key, DESIGN_AREA_TEMPLATES_TAB.SEARCH_BY_CATEGORY_LABEL.value)}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => setFilterVisible(!filterVisible)}
                content={
                  <PopoverContainer>
                    <ClearAll
                      onClick={() => [
                        setFilterVisible(false),
                        updateSelectedView('view-templates', null),
                      ]}
                    >
                     {t(DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.key, DESIGN_AREA_TEMPLATES_TAB.CLEAR_ALL_FILTER_ACTION.value)}
                    </ClearAll>
                    <Select
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder="Select Category"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                      {t(DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.ALL_CATEGORY_DROPDOWN_OPTION.value)}
                      </Option>
                      {defaultTemplates.length > 0 &&
                        defaultTemplates.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>
                    <Button
                      type="primary"
                      onClick={() => [setFilterVisible(false), seeAllByCategory(filterOption)]}
                    >
                      {t(DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.key, DESIGN_AREA_TEMPLATES_TAB.APPLY_FILTERS_BUTTON.value)}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot count={selectedCategory ? null : 0}>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>
            </>
          }
        />
        {!fetchingCategories && selectedView === 'view-search-template' && (
          <NoteText>
            {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_FOUND_COUNT.value, { templatesCount: searchedTemplates?.count  })}
          </NoteText>
        )}
      </TabSearchContainer>
    );
  };

  const renderEmptyView = () => (
    <EmptySettingsDetails inverted={isSelectionMode ? 1 : 0}>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
        <div className="empty-txt">
          <span>{t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATES_LIST_EMPTY.value) + `${isSelectionMode ? '' : t(DESIGN_AREA_TEMPLATES_TAB.CLICK.key, DESIGN_AREA_TEMPLATES_TAB.CLICK.value)}`}</span>
          {!isSelectionMode && (
            <>
              <span
                className="empty-links"
                onClick={() => enableModalVisibility('create-template', null)}
              >
                {t(DESIGN_AREA_TEMPLATES_TAB.HERE.key, DESIGN_AREA_TEMPLATES_TAB.HERE.value)}
              </span>
              <span>{t(DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.key, DESIGN_AREA_TEMPLATES_TAB.EMPTY_LIST_CREATE_NEW_TEMPLATE.value)}</span>
            </>
          )}
        </div>
    </EmptySettingsDetails>
  );

  const tabHeaderView = category => {
    return (
      <Col>
        <TabMenuHeader inverted={isSelectionMode ? 1 : 0} className={attachmentTemp ? 'attachmentTemp' : 'categoryName'}><h2>{category.categoryName}</h2></TabMenuHeader>
        {category.templates && category.templates.length >= 4 && (
          <TabMenuHeader inverted={isSelectionMode ? 1 : 0} onClick={() => seeAllByCategory(category)}>
            <div className='see-all'>{t(DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.key, DESIGN_AREA_TEMPLATES_TAB.SEE_ALL_TEMPLATES_ACTION.value)}</div>
          </TabMenuHeader>
        )}
      </Col>
    );
  };

  const singleTemplate = (category, templateObj, action) => {
    let categoryByTemplate = {
      id: templateObj.id,
      name: templateObj.name,
      categoryName: category?.categoryName,
      categoryId: category?.categoryId,
      tags: templateObj.tags,
    };
    templateObj.categoryName = category?.categoryName;
    return (
      <TemplateMenuItem
        noCarousel={attachmentTemp}
        templateObj={templateObj}
        inverted={isSelectionMode ? 1 : 0}
        previewText={t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.value)}
        onMenuClick={(e) => {
          if (isSelectionMode && onSelect) {
            onSelect(templateObj);
          } else {
            updateSelectedView('view-template-pages', templateObj, action);
          }
        }}
        renderDropDown={() =>
          isSelectionMode ? (
            <div />
          ) : (
            (templateObj.permission === "write") &&
            (checkUserAccess('client')
              ? templateObj.type === 'usertemplate'
                ? true
                : false
              : templateObj.type === 'mastertemplate'
              ? true
              : false) && (
              <DropdownDetails
                id={`${templateObj.id}-template`}
                className="dropdown-menu"
                onClick={e => e.stopPropagation()}
              >
                <Dropdown
                  overlay={
                    <Menu>
                        <Menu.Item key="0" onClick={() => redirectToTemplate(templateObj)}>
                          {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                        <Menu.Item
                          key="1"
                          onClick={() =>
                            enableModalVisibility('delete-template', categoryByTemplate)
                          }
                        >
                          {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={() => enableModalVisibility('add-tag', categoryByTemplate)}
                      >
                        {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value)}
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                  getPopupContainer={() => document.getElementById(`${templateObj.id}-template`)}
                >
                  <Icon type="more" />
                </Dropdown>
              </DropdownDetails>
            )
          )
        }
        attachmentTemp={attachmentTemp}
      />
    );
  };

  const templateCardView = (category, action) => {
    return category.documents && category.documents.length ? (
      <TabMenuItemContainer>
        {category.documents.map(templateObj => {
          return singleTemplate(category, templateObj, action);
        })}
      </TabMenuItemContainer>
    ) : (
      <div></div>
    );
  };

  const renderCategory = () => {
    return (
      <>
        {categoryTemplates.map(category => (
          <TabMenuHeaderContainer key={category.categoryId}>
            {tabHeaderView(category)}
            {templateCardView(category, 'view-templates')}
          </TabMenuHeaderContainer>
        ))}
      </>
    );
  };

  const renderTemplates = () => {
    return (
      <div>
        <SubTabHeading className="with-icon">
          <Icon type="left" onClick={() => updateSelectedView(previousView, null)} />
          <div className="subtab-name">{selectedTemplate.name}</div>
            {(checkUserAccess('client')
              ? selectedTemplate.type === 'usertemplate'
                ? true
                : false
              : selectedTemplate.type === 'mastertemplate'
              ? true
              : false) && (
              <DropdownDetails
                id={`${selectedTemplate.id}-template`}
                className="dropdown-menu dropdown-visible"
                onClick={e => e.stopPropagation()}
              >
                <Dropdown
                  overlay={
                    <Menu>
                        <Menu.Item key="0" onClick={() => redirectToTemplate(selectedTemplate)}>
                          {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_EDIT_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                        <Menu.Item
                          key="1"
                          onClick={() => enableModalVisibility('delete-template', selectedTemplate)}
                        >
                          {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_DELETE_DROPDOWN_OPTION.value)}
                        </Menu.Item>
                      <Menu.Item
                        key="2"
                        onClick={() => enableModalVisibility('add-tag', selectedTemplate)}
                      >
                        {t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_MANAGE_TAGS_DROPDOWN_OPTION.value)}
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={['click']}
                  getPopupContainer={() =>
                    document.getElementById(`${selectedTemplate.id}-template`)
                  }
                >
                  <Icon type="more" />
                </Dropdown>
              </DropdownDetails>
            )}
        </SubTabHeading>
        <ApplyTemplate template={selectedTemplate}/>
        {selectedTemplate && selectedTemplate.pages.length > 0 ? (
          <TabMenuItemContainer>
            {selectedTemplate.pages.map((pageObj, index) => {
              let pageDetails = {
                name: '',
                thumbnail: pageObj.thumbnail,
                type: 'colored',
                elementDetails: pageObj,
                actionType: 'replace-template-page',
                isTemplate: true
              };
              return (
                <TabMenuItemDetails key={pageObj.pageId} type="page" size="big">
                  <EditorElement element={pageDetails} />
                  <PageCountIndicator>
                    <div className="page-counter"> {t(DESIGN_AREA_TEMPLATES_TAB.PAGE_NUM.key, DESIGN_AREA_TEMPLATES_TAB.PAGE_NUM.value)} {' ' + index + 1} </div>
                  </PageCountIndicator>
                  <Tooltip title={t(DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.key, DESIGN_AREA_TEMPLATES_TAB.TEMPLATE_PREVIEW_TOOLTIP.value)} placement="top">
                    <div
                      className="preview-button"
                      onClick={e =>
                        previewModalVisibility(e, 'preview-thumbnail', selectedTemplate, index)
                      }
                    >
                      <Icon type="eye" />
                    </div>
                  </Tooltip>
                </TabMenuItemDetails>
              );
            })}
          </TabMenuItemContainer>
        ) : (
          <div></div>
        )}
      </div>
    );
  };

  const showMoreView = text => {
    const loaderStyles = { top: '0px' };
    return (
      <>
        {loadMore && renderLoader(loaderStyles)}
        {noData && <NoDataView small>{text}</NoDataView>}
      </>
    );
  };

  const renderSearchView = () => {
    return searchedTemplates.templates?.length > 0 ? (
      <>
        <TabMenuItemContainer>
          {searchedTemplates.templates.map(data => {
            const categoryDetails = {
              categoryId: data.categoryId,
            };
            return singleTemplate(categoryDetails, data, 'view-search-template');
          })}
        </TabMenuItemContainer>
        {showMoreView(t(DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.key, DESIGN_AREA_TEMPLATES_TAB.GOT_ALL_RESULTS.value))}
      </>
    ) : (
      <NoDataView>{t(DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.key, DESIGN_AREA_TEMPLATES_TAB.NO_TEMPLATES_AVAILABLE.value)}</NoDataView>
    );
  };

  const renderTabBody = () => {
    switch (selectedView) {
      case 'view-templates':
        return renderCategory();
      case 'view-template-pages':
        return selectedTemplate && renderTemplates();
      case 'view-search-template':
        return renderSearchView();
      default:
        break;
    }
  };

  const renderModals = () => {
    switch (selectedAction) {
      case 'create-template':
        return (
          <CreateTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            onSucess={redirectToTemplate}
            categoryType="template"
          />
        );
      case 'delete-template':
        return (
          <DeleteTemplateModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            categoryType="template"
            onSucess={onSuccessDeletion}
          />
        );

      case 'add-tag':
        return (
          <AddTagsModal
            visible={updateModalVisibility}
            onCancel={success => onSuccessAddition(success)}
            target={selectedTemplate}
            isEmail={false}
            isElement={false}
          />
        );

      case 'preview-thumbnail':
        return (
          <PreviewModal
            visible={updateModalVisibility}
            onCancel={disableModalVisibility}
            targetTemplate={selectedTemplate}
            currentIndex={pageIndex}
          />
        );

      case 'template-locked':
        return (
          <Modal
            title={t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.key}`, TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_MODAL_TITLE.value)}
            centered
            width="875px"
            visible={true}
            onCancel={() => setUpdateModalVisibility(false)}
            footer={[
              <Button key="back" onClick={() => setUpdateModalVisibility(false)}>
                {t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.key}`, TEMPLATE_LOCKED_BY_MODAL.CANCEL_BUTTON.value)}
              </Button>,
              <Button key="submit" type="primary" onClick={() => setUpdateModalVisibility(false)}>
                {t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.key}`, TEMPLATE_LOCKED_BY_MODAL.OK_BUTTON.value)}
              </Button>,
            ]}
          >
            <ModalBody>
              <div className="warning-text">
                <span> {t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.key}`, TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED.value)} </span>
                {lockedBy && (
                  <>
                    <span>{t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.key}`, TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY.value)}</span>{' '}
                    <span className="text-highlighter"> {lockedBy.displayName}</span>
                    <span> {t(`TEMPLATE_LOCKED_BY_MODAL:${TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.key}`, TEMPLATE_LOCKED_BY_MODAL.TEMPLATE_LOCKED_BY_TEMPLATE_NAME.value, { templateName: lockedBy.displayName })} </span>
                  </>
                )}
              </div>
            </ModalBody>
          </Modal>
        );
      default:
        break;
    }
  };

  return (
    <TabMenuContainer
      style={
        isSelectionMode
          ? { marginBottom: 0, position: 'relative' }
          : {
              marginTop:
                selectedView === 'view-templates'
                  ? checkUserAccess('master')
                    ? '42px'
                    : '100px'
                  : checkUserAccess('master')
                  ? '75px'
                  : '125px',
            }
      }
      className={attachmentTemp && 'attachmentTemp'}
    >
      {!isSelectionMode && (
        <SearchNavWrapper className={activetabIndex === 0 ? 'showSearch' : 'hideSearch'}>
          {!initialLoader && (
            <>
              {checkUserAccess('client') && (
                <Tabs defaultActiveKey="usertemplate" onChange={handleTemplateType}>
                <TabPane
                  tab={t(DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TAB_TITLE.key, DESIGN_AREA_TEMPLATES_TAB.MY_DESIGNS_TAB_TITLE.value)}
                  key="usertemplate"
                ></TabPane>
                <TabPane
                  tab={t(
                    DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TAB_TITLE.key,
                    DESIGN_AREA_TEMPLATES_TAB.MASTER_DESIGNS_TAB_TITLE.value,
                  )}
                  key="mastertemplate"
                ></TabPane>
              </Tabs>
              )}
              {renderSearchBar()}
            </>
          )}
        </SearchNavWrapper>
      )}
      {isSelectionMode && renderSearchBar()}
      {fetchingCategories && renderLoader()}
      <div>
        {!fetchingCategories && (
          <div className={isSelectionMode ? 'categoryContainer' : ''} onScroll={onScroll}>
            {categoryTemplates.length === 0 && renderEmptyView()}
            {categoryTemplates.length > 0 && renderTabBody()}
          </div>
        )}
      </div>
      {!isSelectionMode && (
        <HelpGuideWrapper>
          <div className="help-container">
          <div
              className="help-action-btn"
              onClick={() => enableModalVisibility('create-template', null)}
            >
              <Icon type="plus" />{' '}
              {t(
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.key,
                DESIGN_AREA_TEMPLATES_TAB.CREATE_NEW_TEMPLATE_BUTTON.value,
              )}
            </div>
          </div>
        </HelpGuideWrapper>
      )}
      {!fetchingCategories && updateModalVisibility && selectedAction && renderModals()}
    </TabMenuContainer>
  );
};

export default withTranslation(NAMESPACES)(TemplateTabDetails);
